
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { ValidationProps } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { CodetableOptions, LoadCodeItemsParams } from 'app/area/import-mappings/types';

export interface CodeListItem {
  id: number;
  codetableId: number;
  description: string;
  disabled?: string;
  childrenCount: number;
  importMapping: ImportMapping[];
}

export interface CodeListBranch {
  id: number;
  items: CodeListItem[];
  numberOfResults: number;
}

export interface CodeListBranchState {
  id: number;
  fetching?: boolean;
  needsReload?: boolean;
  isUpdatingParent?: boolean;
  open?: boolean;
}

export type ImportMappingsOptions = {
  [key: string]: {
    fetching: boolean;
    codes: CodeComplexValue<number>[];
    currentOptions: CodeComplexValue<number>[];
    loadOptionsParams?: LoadCodeItemsParams;
  };
};

export interface ImportMappingsListState {
  itemAccess: AccessCodes;
  fetchingCodetableId: number;
  category: CodeComplexValue<number>;
  requestedSearchModel: FilterSearchModel;
  codeListBranchState: CodeListBranchState[];
  codeListBranch: CodeListBranch[];
  codetableOptions: { [key: string]: CodetableOptions };
  fetchingItemAccess: number;
  fetchingCodetableItemAccess?: number;
  includeInactive: CodeFieldIncludeInactiveKey;
  options: ImportMappingsOptions;
  fetchingImportSetData: boolean;
  fetchingCodetableData: boolean;
  fetchingCodetableMetadata: boolean;
  codetableMetadata: CodetableMetadata;
  numberOfResults: number;
  updating: boolean;
  modifiedItems: ModifiedCodeMappings[];
  currentCode: CodeListItem;
  codetable: ComplexValue<number>;
  importSet: ComplexValue<number>;
  validation: { [key: string]: ValidationProps };
}

export interface LoadCodeItemsPayload {
  importSetId: number;
  codetableId: number;
  categoryId?: number;
  parentId: number;
  startIndex: number;
  maxResults: number;
  includeInactiveCodes: CodeFieldIncludeInactive;
  searchModel: FilterSearchModel;
}

export enum CodeFieldWireKey {
  code = 'code',
}

export enum CodeFieldIncludeInactiveKey {
  active = 'active',
  all = 'all'
}

export interface CodeFieldWire {
  id: number;
  searchRequired: boolean;
  label?: string;
}

export type CodeFieldIncludeInactive = {
  enabled: boolean;
};

export type CodeFieldIncludeInactiveValues = { [key in keyof typeof CodeFieldIncludeInactiveKey]: CodeFieldIncludeInactive; };

export interface AccessCodes {
  id: number;
  edit: boolean;
  delete: boolean;
  move: boolean;
  readonlySubsets?: number[];
}

export interface CodetableMetadata {
  label: string;
  codetableCategory: CodeFieldWire;
  code: CodeFieldWire;
  hierarchy: boolean;
}

export enum ImportMappingType {
  Init,
  Updated,
  Deleted,
  New,
  NewUpdated,
  Error
}

export interface ImportMapping {
  importNumber?: number;
  externalValue: string;
  existingExternalValue?: string;
  type: ImportMappingType;
}

export interface ModifiedImportMappings {
  id: number;
  codetable: number;
  description: string;
  importMapping: ImportMapping[];
}

export interface ModifiedCodeMappings {
  id: number;
  codetable: number;
  importMapping: ImportMapping[];
  description: string;
  code?: ComplexValue<number>;
  codeCategory?: ComplexValue<number>;
}
